@if (data.title) {
  <h2 mat-dialog-title>{{ data.title }}</h2>
}
<mat-dialog-content>
  {{ data.body }}
</mat-dialog-content>
<mat-dialog-actions>
  <button matButton="text" mat-dialog-close>{{ data.declineText || 'No' }}</button>
  <button matButton="filled" [mat-dialog-close]="true">{{ data.confirmText || 'Yes' }}</button>
</mat-dialog-actions>
